import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { RootState } from 'src/core/redux/reducer'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Icon } from '@material-ui/core'


interface IProps extends WithI18n,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
  dispatch: any;
  children: React.ReactElement<any>;
  onCancel: () => void;
  onConfirm: () => void;
  cancelLabel?: string;
  confirmLabel?: string;
  title: string;
  content: string;
  disabled?: boolean;
  fullScreen?: boolean;
}

interface IStates {
    open: boolean;
}

class ItemWithModal extends React.Component<IProps, IStates> {

  state = {
    open: false
  }


  render() {
    const {t, children, content, onConfirm, onCancel, cancelLabel, confirmLabel, disabled, fullScreen} = this.props
    return (
        <React.Fragment>
            {React.cloneElement(children, {
                    onClick: () => {
                        this.setState({open: true})
                    }
                })}
                <Dialog
                    open={this.state.open}
                    maxWidth="sm"
                    fullWidth={true}
                    {...fullScreen && {fullScreen: true}}
                    disableEnforceFocus
                >
                    <DialogTitle>{this.renderTitle()}</DialogTitle>

                    <DialogContent style={{overflow:"visible"}}>{content}</DialogContent>

                    {(onCancel || onConfirm) &&
                        <DialogActions>
                            {onCancel &&
                            <Button color="primary" onClick={this.cancel}>
                                {cancelLabel || t.cancel}
                            </Button>
                            }
                            {onConfirm &&
                            <Button
                                variant="raised"
                                color="primary"
                                onClick={this.confirm}
                                disabled={disabled || false}
                            >
                                {confirmLabel || t.confirm}
                            </Button>
                            }
                        </DialogActions>
                    }
                </Dialog>
        </React.Fragment>
    )
  }

    confirm = () => {
        if(this.props.onConfirm) this.props.onConfirm();
        this.setState({
            open: false,
        });
    };

    cancel = () => {
        if(this.props.onCancel) this.props.onCancel();
        this.setState({
            open: false,
        });
    };

    renderTitle = () => {
        const {
            fullScreen, title
        } = this.props;
        if(fullScreen) {
            return (
                <div style={{display: "flex", alignItems:"center"}}>
                    <div style={{flex: 1}}>
                        {title}
                    </div>
                    <IconButton
                        onClick={this.cancel}
                    >
                        <Icon>close_icon</Icon>
                    </IconButton>
                </div>
            )
        } else {
            return title;
        }
    }
 
}

const state2props = (state: RootState) => ({
});

const dispatch2props = (dispatch: any) => ({
});

export default compose(
    withI18n,
    connect(state2props, dispatch2props),
)(ItemWithModal)



// WEBPACK FOOTER //
// ./src/shared/ItemWithModal/ItemWithModal.tsx